import { Observable, observe, Scope } from 'wdc-cube'
import { AnaliseRow } from './analise.types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class AnaliseScope extends Scope {
    readonly header = new HeaderScope()
    
    @observe() waiting?: WaitingScope

    @observe() analises = [] as AnaliseRow[]
    @observe() nomeAnaliseInputRef = '' as string
    @observe() idSelected = 0 as number

    onFind = Scope.ASYNC_ACTION
    onNew = Scope.ASYNC_ACTION
    onEdit = Scope.ASYNC_ACTION
    onDelete = Scope.ASYNC_ACTION
}

export default AnaliseScope
